/* AA custom footer — newsletter right fly-in.
   Opens the panel from the footer's "Newsletter" trigger; closes on overlay/✕/Escape.
   Auto-opens on load if the customer form came back with a success/error message (the
   form posts and reloads the page, so we surface the result by re-opening the panel). */
(function () {
  function root() {
    return document.querySelector('.aa-footer-nl[data-aa-nl-root]');
  }

  function open() {
    var r = root();
    if (!r) return;
    r.classList.add('is-open');
    // Compensate for the vanishing scrollbar so the page (and the startpage slider) doesn't
    // shift sideways when scroll locks.
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.body.classList.add('aa-footer-nl-lock');
    document.querySelectorAll('[data-aa-nl-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
    var panel = r.querySelector('.aa-footer-nl__panel');
    if (panel) panel.focus();
  }

  function close() {
    var r = root();
    if (!r) return;
    r.classList.remove('is-open');
    document.body.classList.remove('aa-footer-nl-lock');
    document.body.style.paddingRight = '';
    document.querySelectorAll('[data-aa-nl-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  function init() {
    document.querySelectorAll('[data-aa-nl-open]').forEach(function (btn) {
      if (btn.dataset.aaNlBound) return;
      btn.dataset.aaNlBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    var r = root();
    if (r && !r.dataset.aaNlBound) {
      r.dataset.aaNlBound = '1';
      // Relocate the fly-in (overlay + white panel) to <body> so its z-index sits at the root
      // stacking context — otherwise on the startpage the footer is trapped below the header
      // (the home slider creates stacking contexts) and the panel can't cover the navigation.
      document.body.appendChild(r);
      r.addEventListener('click', function (e) {
        if (e.target.closest('[data-aa-nl-close]')) {
          e.preventDefault();
          close();
        }
      });
      r.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') close();
      });
      // Re-open after a submit so the success/error message is visible.
      if (r.querySelector('.newsletter-form__message')) open();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
